import { YesNoEnum } from '../HouseholdOutgoings/types';

export const residencyQuestions: Record<string, any> = {
  nationality: {
    labelKey: 'applicationForm.RESIDENCY.selectNationality.label',
  },
  hasPermanentResidency: {
    labelKey: 'applicationForm.RESIDENCY.hasResidency.label',
    explanationKey: 'applicationForm.RESIDENCY.hasResidency.explanation',
    options: [
      { labelKey: 'common.yes', value: YesNoEnum.YES },
      { labelKey: 'common.no', value: YesNoEnum.NO },
    ],
  },
  remainingVisaMonths: {
    labelKey: 'applicationForm.RESIDENCY.remainingVisaMonths.label',
    adornmentKey: 'common.months',
  },
};
